<p-table [value]="paginationResult.entities"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize"
  [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]"
  [paginator]="true"
  [(selection)]="selectedEntities"
  [loading]="loading"
  [rowHover]="true"
  [showCurrentPageReport]="true"
  currentPageReportTemplate=
  "{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
  class="custom-table"
  styleClass="p-datatable-striped"
  >

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{ 'vehicleAssignments.header' | translate }}
    </div>
  </ng-template>
  <!-- #endregion -->


  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- EMPRESA -->
      <th pSortableColumn="company.name" [pSortableColumnDisabled]="!isCompaniesListLoaded">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.companies.company' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="company.name"></p-sortIcon>
              <p-columnFilter field="billingAccount" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="companiesList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}" (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                    <ng-template let-option pTemplate="item">
                      <div>
                        <span class="ml-1">({{option.code}}) {{option.name}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </div>

        </div>
      </th>

      <!-- START DATE -->
      <th pSortableColumn="startDate">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.cardLists.assignDateShort' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="startDate"></p-sortIcon>
            <p-columnFilter field="startDate" type="date" matchMode="dateIs"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- ENDS DATE -->
      <th pSortableColumn="endDate">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.cardLists.deassignDateShort' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="endDate"></p-sortIcon>
            <p-columnFilter field="endDate" type="date" matchMode="dateIs"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- DELEGATION -->
      <th pSortableColumn="delegation.name" [pSortableColumnDisabled]="!isDelegationListLoaded">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.delegations.delegation' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN SORT && FILTER ICONS -->
            @if (isDelegationListLoaded) {
              <div class="d-flex align-items-center h-100">
                <p-sortIcon field="delegation.name"></p-sortIcon>
                <p-columnFilter field="delegation" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="delegationList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}" (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                      <ng-template let-option pTemplate="item">
                        <div>
                          <span class="ml-1">({{option.code}}) {{option.name}}</span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            } @else {
              <div class="d-flex align-items-center h-100" [style]="{'margin-right':'10px'}">
                <mat-spinner
                  [diameter]="20"
                  strokeWidth="3"
                  [color]="primary">
                </mat-spinner>
              </div>
            }
          </div>

        </div>
      </th>

      <!-- Subdelegation -->
      <th pSortableColumn="subDelegation.name" [pSortableColumnDisabled]="!isSubdelegationListLoaded">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.subdelegations.subdelegation' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN SORT && FILTER ICONS -->
            @if (isSubdelegationListLoaded) {
              <div class="d-flex align-items-center h-100">
                <p-sortIcon field="subDelegation.name"></p-sortIcon>
                <p-columnFilter field="subdelegation" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="subdelegationList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}" (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                      <ng-template let-option pTemplate="item">
                        <div>
                          <span class="ml-1">({{option.code}}) {{option.name}}</span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            } @else {
              <div class="d-flex align-items-center h-100" [style]="{'margin-right':'10px'}">
                <mat-spinner
                  [diameter]="20"
                  strokeWidth="3"
                  [color]="primary">
                </mat-spinner>
              </div>
            }
          </div>

        </div>
      </th>

      <!-- CECO -->
      <th pSortableColumn="ceco.description" [pSortableColumnDisabled]="!isCecoListLoaded">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.ceco' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN SORT && FILTER ICONS -->
            @if (isSubdelegationListLoaded) {
              <div class="d-flex align-items-center h-100">
                <p-sortIcon field="ceco.description"></p-sortIcon>
                <p-columnFilter field="ceco" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="cecoList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}" (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                      <ng-template let-option pTemplate="item">
                        <div>
                          <span class="ml-1">({{option.code}}) {{option.description}}</span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            } @else {
              <div class="d-flex align-items-center h-100" [style]="{'margin-right':'10px'}">
                <mat-spinner
                  [diameter]="20"
                  strokeWidth="3"
                  [color]="primary">
                </mat-spinner>
              </div>
            }
          </div>

        </div>
      </th>
      <!-- DELETE -->
      <th class="button-column"></th>

    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-va>
    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(va)">
      <td>({{va.company?.code}}) {{va.company?.name}}</td>
      <td>{{va.startDate | date: 'dd/MM/yyyy'}}</td>
      <td>{{va.endDate | date: 'dd/MM/yyyy'}}</td>
      @if (va.delegation) {
        <td>({{va.delegation.code}}) {{va.delegation.name}}</td>
      } @else {
        <td>N/A</td>
      }
      @if (va.subDelegation) {
        <td>({{va.subDelegation.code}}) {{va.subDelegation.name}}</td>
      } @else {
        <td>N/A</td>
      }
      <td>({{va.ceco?.code}}) {{va.ceco?.description}}</td>
      <td>
        @if (canDelete) {
          <div>
            <button  type="button" class="btn custom-table-remove-button" (click)="onDeleteAssignment(va)">
              <svg-icon
                src="assets/icons/trash.svg"
                class="d-flex flex-wrap custom-table-remove-button-icon"
                [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
              ></svg-icon>
            </button>
          </div>
        }

      </td>
    </tr>
  </ng-template>


  <!-- TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
          {{ 'table.tableEmptyMessage' | translate }}!
        </div>
      </td>
    </tr>
  </ng-template>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <tr>
      <td colspan="7" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">
          <!-- EXCEL BUTTON -->
          <app-table-excel-button class="buttonTableExcel"  (btnClick)="exportExcel()"></app-table-excel-button>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>
<app-vehicle-assignments-form [entities]="paginationResult.entities"></app-vehicle-assignments-form>
<p-confirmDialog
  #saveEventDialog
  [header]="'confirm.critic' | translate"
  [message]="'control-panel.delete-dialog.message' | translate"
  class="custom-dialog"
  icon="pi pi-exclamation-triangle"
  key="vehicle-assignments-list"
  >
  <ng-template pTemplate="footer">
    <!-- REJECT BUTTON -->
    <button (click)="saveEventDialog.onReject()" class="custom-button">
      {{ 'general.no' | translate }}
    </button>
    <!-- ACCEPT BUTTON -->
    <button (click)="saveEventDialog.onAccept()" class="custom-button">
      {{ 'general.yes' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>